import { normalizeLooseText, normalizePart } from '@/helpers/string.js'

const isHighlightedCustomerMatch = (highlightedCustomer, customerName) => {
    if (!highlightedCustomer || customerName == null) return false

    const selected = normalizeLooseText(highlightedCustomer)
    const current = normalizeLooseText(customerName)

    return selected.length > 0 && selected === current
}

const isHighlightedPartMatch = (selectedPart, partNumber) => {
    const selected = normalizePart(selectedPart)
    const current = normalizePart(partNumber)

    return Boolean(selected) && Boolean(current) && selected === current
}

const compareSelectedPartFirst = (partNumberA, partNumberB, selectedPart) => {
    const isSelectedA = isHighlightedPartMatch(selectedPart, partNumberA)
    const isSelectedB = isHighlightedPartMatch(selectedPart, partNumberB)

    if (isSelectedA === isSelectedB) return 0
    return isSelectedA ? -1 : 1
}

const compareHighlightedCustomerFirst = (customerNameA, customerNameB, highlightedCustomer) => {
    const isCustomerA = isHighlightedCustomerMatch(highlightedCustomer, customerNameA)
    const isCustomerB = isHighlightedCustomerMatch(highlightedCustomer, customerNameB)

    if (isCustomerA === isCustomerB) return 0
    return isCustomerA ? -1 : 1
}

const getDashboardRowCustomerName = (row = {}) =>
    row?.customer ?? row?.customer_name ?? row?.customerName ?? row?.bill_name ?? row?.billName

const buildDashboardRowHighlightClass = ({
    highlightedCustomer = '',
    customerName = null,
    selectedPart = '',
    partNumber = null,
    activePart = false,
} = {}) => {
    const isCustomerMatch = isHighlightedCustomerMatch(highlightedCustomer, customerName)
    const isPartMatch = isHighlightedPartMatch(selectedPart, partNumber)

    return {
        'active-part': activePart,
        'left-accent-1': isCustomerMatch || isPartMatch,
        'left-accent-2': isCustomerMatch && isPartMatch,
    }
}

const getDashboardCustomerCellClass = (highlightedCustomer, customerName) => ({
    'customer-bold': isHighlightedCustomerMatch(highlightedCustomer, customerName),
})

export {
    buildDashboardRowHighlightClass,
    compareHighlightedCustomerFirst,
    compareSelectedPartFirst,
    getDashboardCustomerCellClass,
    getDashboardRowCustomerName,
    isHighlightedCustomerMatch,
    isHighlightedPartMatch,
}
